import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "pitstop_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (tire, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((p) => p.tire_id === tire.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: Math.min(next[idx].qty + qty, tire.quantity || 20) };
        return next;
      }
      return [
        ...prev,
        { tire_id: tire.id, brand: tire.brand, size: tire.size, price: tire.price, qty, image: tire.images?.[0] || null },
      ];
    });
    setOpen(true);
  };

  const remove = (tire_id) => setItems((prev) => prev.filter((p) => p.tire_id !== tire_id));
  const setQty = (tire_id, qty) =>
    setItems((prev) => prev.map((p) => (p.tire_id === tire_id ? { ...p, qty: Math.max(1, qty) } : p)));
  const clear = () => setItems([]);

  const total = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  const value = { items, add, remove, setQty, clear, total, count, open, setOpen };
  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export function useCart() {
  const v = useContext(CartCtx);
  if (!v) throw new Error("useCart must be used within CartProvider");
  return v;
}

export function fmtFt(n) {
  return new Intl.NumberFormat("hu-HU").format(n) + " Ft";
}
